import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=01768c40&"
import script from "./ShareButtons.vue?vue&type=script&lang=js&"
export * from "./ShareButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports